import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { RiArrowDropDownLine } from "react-icons/ri";
import apiBaseUrl from "../apiBase";

// Initialize array to hold data returned from TestData function
let projectData = [];

const getTextValue = (item, keys) => {
	for (const key of keys) {
		const value = item?.[key];
		if (value !== undefined && value !== null) {
			return String(value);
		}
	}
	return "";
};

const compareText = (a, b, keys) =>
	getTextValue(a, keys).localeCompare(getTextValue(b, keys));

const getProjectId = (project) => project?.ProjectID ?? project?.projectId;
const getProjectName = (project) =>
	getTextValue(project, ["ProjectName", "projectName"]);

// Retrieve data, group and sort as needed.
export function ProjectData(groupType) {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	// useEffect(() => {
	//   setLoading(true);
	//   fetch(
	//     `https://gisstage.marc2.org/transapi_test/api/TCPApplication`
	//   )
	//     .then((response) => response.json())
	//     .then(setData)
	//     .then(() => setLoading(false))
	//     .catch(setError);
	// }, []);

	//This code is an alternative to the code above.  It uses async/await instead of .then. It is a little more readable, but does the same thing. For bigger projects, it is recommended to use async/await.
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await fetch(`${apiBaseUrl}/LRTPProject/getall`);
				if (!response.ok) {
					throw new Error(`Error: ${response.statusText}`);
				}
				const data = await response.json();
				setData(data);
				setLoading(false);
			} catch (error) {
				setError(error);
			}
		};

		fetchData();
	}, []);

	if (loading) return <h1>Loading...</h1>;
	if (error) return <pre>{JSON.stringify(error)}</pre>;
	if (!data) return null;

	let sorted = [];

	// function groupAndCount(arr, key) {
	//   const grouped = arr.reduce((acc, obj) => {
	//     const keyValue = obj[key];
	//     acc[keyValue] = (acc[keyValue] || 0) + 1;
	//     return acc;
	//   }, {});
	//   return grouped;
	// }

	// // get comment counts by project id, convert to an array, and drop unneeded columns
	// const commentsGrouped = groupAndCount(commentdata, 'ID');
	// const commentArray = Object.entries(commentsGrouped);

	// // add columns for ProjectNumber and CommentCount
	// const commentCounts = commentArray.map((item) => {
	//   return {
	//     ...item, // Copy existing properties
	//     ProjectNumber: +item[0], // Create new property with the desired name
	//     CommentCount: +item[1], // Create new property with the desired name
	//   };
	// });

	// // remove unneeded columns
	// const columnsToRemove = ["0", "1"];
	// for (let i = 0; i < commentCounts.length; i++) {
	//   columnsToRemove.forEach(column => delete commentCounts[i][column]);
	// }

	// const data_wComments = data.map(item1 => {
	// const item2 = commentCounts.find(item => item.ProjectNumber === item1.ProjectNumber);
	// console.log("item2: " + item2);
	// let item3 = 0;
	//   if (item2 === 'undefined' || item2 === undefined) {
	//     item3 = 0;
	//   }
	//   else {
	//     item3 = item2.CommentCount;
	//   }
	//   return {
	//     ...item1,
	//     CommentCount: item3
	//   };
	// });

	// console.log(data_wComments);

	// Group data by Organization
	if (groupType === "Organization") {
		sorted = [...data].sort(
			(a, b) =>
				compareText(a, b, [
					"Sponsor",
					"sponsor",
					"Organization",
					"organization",
				]) ||
				compareText(a, b, [
					"ConstrainedIllustrative",
					"constrainedIllustrative",
					"ProjectClass",
					"projectClass",
				]),
		);

		const groupedData = sorted.reduce((acc, current) => {
			const group =
				getTextValue(current, [
					"Sponsor",
					"sponsor",
					"Organization",
					"organization",
				]) || "Unspecified";

			// If the group doesn't exist in the accumulator, create an array for it
			if (!acc[group]) {
				acc[group] = [];
			}

			// Add the current data to the group's array
			acc[group].push(current);
			return acc;
		}, {});

		projectData = groupedData;
	}
	// Group data by System
	else if (groupType === "System") {
		sorted = [...data].sort(
			(a, b) =>
				compareText(a, b, ["System", "system"]) ||
				compareText(a, b, ["ProjectClass", "projectClass"]),
		);

		const groupedData = sorted.reduce((acc, current) => {
			const group =
				getTextValue(current, ["System", "system"]) || "Unspecified";

			// If the group doesn't exist in the accumulator, create an array for it
			if (!acc[group]) {
				acc[group] = [];
			}

			// Add the current data to the group's array
			acc[group].push(current);
			return acc;
		}, {});

		projectData = groupedData;
	}
	// Group data by Mode
	else if (groupType === "Mode") {
		sorted = [...data].sort(
			(a, b) =>
				compareText(a, b, ["PrimaryMode", "primaryMode", "Mode", "mode"]) ||
				compareText(a, b, ["ProjectClass", "projectClass"]),
		);
		const groupedData = sorted.reduce((acc, current) => {
			const group =
				getTextValue(current, ["PrimaryMode", "primaryMode", "Mode", "mode"]) ||
				"Unspecified";

			// If the group doesn't exist in the accumulator, create an array for it
			if (!acc[group]) {
				acc[group] = [];
			}

			// Add the current data to the group's array
			acc[group].push(current);
			return acc;
		}, {});

		projectData = groupedData;
	} else if (groupType === "Comments") {
		sorted = [...data].sort((a, b) =>
			compareText(a, b, ["ProjectName", "projectName"]),
		);
		projectData = sorted;
	}

	return projectData;
}

// Click handler to set session varialbe for Project Number
const viewClick = (projectnumber) => {
	sessionStorage.setItem("ProjectNumber", projectnumber);
};

//  accordionitem component
export const AccordionItem = ({
	key,
	sorttype,
	isOpen,
	onClick,
	orgprojects,
}) => {
	const contentHeight = useRef();
	const hasProjectClassOrder = orgprojects.some(
		(p) => p?.ProjectClassOrder !== undefined && p?.ProjectClassOrder !== null,
	);
	const hasConstrainedFlag = orgprojects.some((p) =>
		getTextValue(p, ["ConstrainedIllustrative", "constrainedIllustrative"]),
	);

	let accordianItems = [];

	if (hasProjectClassOrder) {
		const constrainedRehab = orgprojects.filter(
			(p) => p.ProjectClassOrder === 1,
		);
		const constrainedOther = orgprojects.filter(
			(p) => p.ProjectClassOrder === 2,
		);
		const illustrative = orgprojects.filter((p) => p.ProjectClassOrder === 3);

		accordianItems = [
			{
				title: "Constrained Rehabilitation Projects",
				projects: constrainedRehab,
				count: constrainedRehab.length,
			},
			{
				title: "Constrained Other Projects",
				projects: constrainedOther,
				count: constrainedOther.length,
			},
			{
				title: "Illustrative Projects",
				projects: illustrative,
				count: illustrative.length,
			},
		];
	} else if (hasConstrainedFlag) {
		const constrained = orgprojects.filter(
			(p) =>
				getTextValue(p, [
					"ConstrainedIllustrative",
					"constrainedIllustrative",
				]).toLowerCase() === "constrained",
		);
		const illustrative = orgprojects.filter(
			(p) =>
				getTextValue(p, [
					"ConstrainedIllustrative",
					"constrainedIllustrative",
				]).toLowerCase() === "illustrative",
		);
		const other = orgprojects.filter((p) => {
			const val = getTextValue(p, [
				"ConstrainedIllustrative",
				"constrainedIllustrative",
			]).toLowerCase();
			return val !== "constrained" && val !== "illustrative";
		});

		accordianItems = [
			{
				title: "Constrained Projects",
				projects: constrained,
				count: constrained.length,
			},
			{
				title: "Illustrative Projects",
				projects: illustrative,
				count: illustrative.length,
			},
			{ title: "Other Projects", projects: other, count: other.length },
		];
	} else {
		accordianItems = [
			{ title: "Projects", projects: orgprojects, count: orgprojects.length },
		];
	}

	return (
		<div className="wrapper">
			<button
				className={`question-container ${isOpen ? "active" : ""}`}
				onClick={onClick}
			>
				<div className="question-content">{sorttype}</div>
				<RiArrowDropDownLine className={`arrow ${isOpen ? "active" : ""}`} />
			</button>

			<div
				ref={contentHeight}
				className="answer-container"
				style={
					isOpen
						? { height: contentHeight.current.scrollHeight }
						: { height: "0px" }
				}
			>
				{/* This is the code to display the data in the accordion */}
				{accordianItems.map((item, index) => (
					<div key={index}>
						<h3>
							{item.title} - (Number of Projects: {item.count})
						</h3>
						<hr />
						<div className="answer-content">
							{item.projects.map((project) => (
								<div key={getProjectId(project) ?? getProjectName(project)}>
									<Link
										className="project-link"
										to="/projectsummary"
										onClick={() => viewClick(getProjectId(project))}
									>
										{getProjectName(project)}
									</Link>
									(Project Number: {getProjectId(project)})
									<hr />
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

// main Accordion component
export const Accordion = ({ sortbyGroup }) => {
	const [activeIndex, setActiveIndex] = useState(null);

	const handleItemClick = (index) => {
		setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	//console.log("sortbyGroup: " + sortbyGroup);
	ProjectData(sortbyGroup);

	//console.log("projectData: " + JSON.stringify(projectData));

	return (
		<div className="container">
			{Object.entries(projectData).map(([groupName, projects], index) => (
				<div className="wrapper question-container" key={groupName}>
					<AccordionItem
						key={projects.ProjectNumber}
						sorttype={groupName}
						isOpen={activeIndex === index}
						onClick={() => handleItemClick(index)}
						orgprojects={projects}
					/>
				</div>
			))}
		</div>
	);
};

export default Accordion;
